// extracted by mini-css-extract-plugin
export default {"link":"DocumentAnchorsLink_link__ni5LF"};